<template>
    <svg
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none">
        <path
            d="M20.6923 8.50011C21.1679 8.50011 21.5881 8.68253 21.9527 9.04736C22.3176 9.41203 22.5 9.83219 22.5 10.3079V11.9231C22.5 12.0281 22.4865 12.1406 22.4595 12.2606C22.4327 12.3804 22.4026 12.4924 22.3693 12.5964L19.5033 19.3589C19.3601 19.6787 19.1199 19.9489 18.7828 20.1694C18.4456 20.3899 18.0938 20.5001 17.7273 20.5001H7.2115V8.50011L13.0288 2.73286C13.2276 2.53419 13.4578 2.41561 13.7193 2.37711C13.9808 2.33861 14.2313 2.38344 14.471 2.51161C14.7108 2.63994 14.8865 2.82203 14.998 3.05786C15.1095 3.29369 15.1333 3.53794 15.0693 3.79061L13.9923 8.50011H20.6923ZM8.7115 9.13861V19.0001H17.7308C17.8012 19.0001 17.8733 18.9809 17.947 18.9424C18.0208 18.9039 18.077 18.8398 18.1155 18.7501L21 12.0001V10.3079C21 10.218 20.9712 10.1443 20.9135 10.0866C20.8558 10.0289 20.7821 10.0001 20.6923 10.0001H12.0963L13.35 4.51936L8.7115 9.13861ZM4.30775 20.5001C3.81058 20.5001 3.385 20.3231 3.031 19.9691C2.677 19.6151 2.5 19.1895 2.5 18.6924V10.3079C2.5 9.81069 2.677 9.38511 3.031 9.03111C3.385 8.67711 3.81058 8.50011 4.30775 8.50011H7.2115V10.0001H4.30775C4.21792 10.0001 4.14417 10.0289 4.0865 10.0866C4.02883 10.1443 4 10.218 4 10.3079V18.6924C4 18.7822 4.02883 18.8559 4.0865 18.9136C4.14417 18.9713 4.21792 19.0001 4.30775 19.0001H7.2115V20.5001H4.30775Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
